export const SET_MAIN_PAGE_CONTENT = 'SET_MAIN_PAGE_CONTENT';
export const SET_POSTS_CONTENT = 'SET_POSTS_CONTENT';
export const ADD_POST_FIELD = 'ADD_POST_FIELD';
export const DELETE_POST_FIELD = 'DELETE_POST_FIELD';
export const CLEAN_FIELDS = 'CLEAN_FIELDS';